// const token: string = "s6QEHqfNhay1|yK-E0@U^cXc(^*~%hPO"


const apiHeader = {
    Accept: '*/*'
}

export default apiHeader;
